<template>
    <basic-form submit-button="Signera" :errors="errors" @submit="submit" @cancel="cancel" />
</template>

<script setup>
    import { ref, toRefs } from "vue";
    import { getConfig, klinikenApi } from "@/api";
    import BasicForm from "@/components/Auth/BasicForm.vue";

    const props = defineProps({
        url: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        tabbnamn: {
            type: String,
            required: false,
            default: null,
        },
    });

    const { data, url, tabbnamn } = toRefs(props);

    const errors = ref({});

    const emit = defineEmits(["success", "error", "cancel"]);

    const submit = async (formData) => {
        formData = { ...formData, ...data.value };
        try {
            const response = await klinikenApi.post(
                `${url.value}sign/basic/`,
                formData,
                getConfig({ params: {} }, tabbnamn.value)
            );
            emit("success", response.data);
        } catch (error) {
            if (error.response.status === 403) {
                emit("error", "Det gick inte att signera.");
            } else if (error.response.status === 400) {
                emit("error", error.response.data);
            } else if (error.response.status === 404) {
                emit("error", error.response.data);
            } else {
                emit("error", "Det gick inte att signera.");
            }
        }
    };

    const cancel = () => {
        emit("cancel");
    };
</script>
